export default __webpack_public_path__ + "static/media/delivery-date-icon.5c452e95.svg";